import { troubleshootSteps } from "@/mocks/homeData";

export default function Steps() {
  return (
    <section id="steps" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-[1200px] mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-700 uppercase tracking-wider">
            <i className="ri-route-line"></i>
            Troubleshooting
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            从地址到网络：8 步定位访问异常
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            排查的原则是「从最简单、成本最低的动作开始」。下面这 8 步按顺序做，
            大多数「网页进不去」的情况都能在前 4 步找到方向。
          </p>
        </div>

        <ol className="mt-9 relative">
          <span className="hidden md:block absolute left-[27px] top-2 bottom-2 w-px bg-background-200"></span>
          {troubleshootSteps.map((s, i) => (
            <li key={s.step} className="relative flex gap-4 md:gap-6 pb-6 last:pb-0">
              <div className="relative z-10 shrink-0">
                <span
                  className={`w-14 h-14 rounded-full flex items-center justify-center font-heading font-bold text-base border-4 border-background-50 ${
                    i === 0 ? "bg-primary-500 text-background-50" : "bg-background-100 text-primary-700"
                  }`}
                >
                  {s.step}
                </span>
              </div>
              <div className="flex-1 rounded-lg bg-background-100 border border-background-200/80 p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-3">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {s.title}
                  </h3>
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-[11px] font-medium">
                    <i className="ri-timer-line"></i>
                    {s.time}
                  </span>
                </div>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-8 rounded-lg bg-primary-50 border border-primary-200 p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
          <span className="w-11 h-11 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-xl shrink-0">
            <i className="ri-lightbulb-line"></i>
          </span>
          <p className="text-sm text-foreground-700 leading-relaxed">
            <strong className="font-semibold text-foreground-950">小提示：</strong>
            每做一步都记录下结果，尤其是具体的报错文字。有了对照，才能判断是哪一步带来了变化，
            而不是反复重试同一个动作。
          </p>
        </div>
      </div>
    </section>
  );
}